export type { LabelColor, LabelVariant, LabelProps } from "./types";
export { Label } from "./Label";
